import * as $ from 'jquery';
import { getCookie, setCookie } from "./util";

const $body = $('body');
const $preloadStylesDark = $('#preload_styles_dark'); // Das #preload_styles_dark-Element
const $iFrame = $('iframe');

let $screenCSS = null;

if ($preloadStylesDark.length > 0) {
    const href = $preloadStylesDark.attr('href'); // Dynamischer href-Wert
    $screenCSS = $(`<link id='contrast-css' rel='stylesheet' type='text/css' href='${href}'></link>`);
}

export function activateContrastButton() {
    $(".icon-contrast").parent().on("click", function (ev) {
        setContrast($('#contrast-css').length === 0);
        ev.stopPropagation();
        return false;
    });

    if ($screenCSS) {
        setContrast(getCookie("contrast") === "true");
    }
}

function setContrast(turnOn) {
    if (turnOn) {
        $('head').append($screenCSS);
        $body.addClass('contrast');
        setCookie("contrast", "true", 7);

        if ($iFrame.length > 0) {
            let oldSrc = $iFrame.attr('src');
            $iFrame.attr('src', oldSrc + '&contrast=1');
        }
    } else {
        $('#contrast-css').remove();
        $body.removeClass('contrast');
        setCookie("contrast", "false", 7);

        if ($iFrame.length > 0) {
            let oldSrc = $iFrame.attr('src');
            let newSrc = oldSrc.replace('&contrast=1', '');
            $iFrame.attr('src', newSrc);
        }
    }
}
